import { Reservation } from "@/types/reservation";
import { format } from "date-fns";
import React from "react";

export const SelectReservationData = ({
  reservation,
}: {
  reservation: Reservation;
}) => {
  const formatDate = (date: Date) => {
    return format(date, "dd.MM.yyyy");
  };
  return (
    <div className="flex flex-col">
      <span>
        {reservation.guest.profile.firstName}{" "}
        {reservation.guest.profile.lastName}{" "}
        {`(${formatDate(new Date(reservation.arrivalDate))} -
          ${formatDate(new Date(reservation.departureDate))})`}
      </span>
    </div>
  );
};
